export function isTabActive() {
    return document && document.visibilityState;
}

export function addTabActivityListener(cb) {
    const event = 'visibilitychange';
    const listener = () => cb(isTabActive());
    document.addEventListener(event, listener);
    return () => document.removeEventListener(event, listener);
}
